export const convertFromJSONCustom = (data: any): any => {
  if (typeof data !== 'object' || data === null) {
    return data;
  }

  if (Array.isArray(data)) {
    return data.map((item) => convertFromJSONCustom(item));
  }

  const convertedData: any = {};
  Object.entries(data).forEach(([key, value]) => {
    if (value === 'True') {
      convertedData[key] = true;
    } else if (value === 'False') {
      convertedData[key] = false;
    } else if (typeof value === 'string' && value.startsWith('jstr=')) {
      convertedData[key] = JSON.parse(value.substring(5));
    } else {
      convertedData[key] = value;
    }
  });

  return convertedData;
};

export const convertToJSONCustom = (data: any): any => {
  if (typeof data !== 'object' || data === null) {
    return data;
  }

  if (Array.isArray(data)) {
    return data.map((item) => convertToJSONCustom(item));
  }

  const convertedData: any = {};
  Object.entries(data).forEach(([key, value]) => {
    if (value !== null) {
      // if (typeof value === 'object') {
      //   convertedData[key] = `jstr=${JSON.stringify(value).replace(/'/g, "\\'").replace(/"/g, '\\"').replace(/\n/g, '\\n')}`;
      // } else if (typeof value === 'string') {
      //   convertedData[key] = value.replace(/'/g, "\\'").replace(/"/g, '\\"').replace(/\n/g, '\\n');
      // } else {
      //   convertedData[key] = value;
      // }
      if (typeof value === 'object') {
        convertedData[key] = `jstr=${JSON.stringify(value).replace(/'/g, "\\'").replace(/\n/g, '\\n')}`;
      } else if (typeof value === 'string') {
        convertedData[key] = value.replace(/'/g, "\\'").replace(/"/g, '\\"').replace(/\n/g, '\\n');
      } else {
        convertedData[key] = value;
      }
    }
  });

  return convertedData;
};

export const convertFromNestedJSON = (nestedJSON: any) => {
  if (nestedJSON === undefined || nestedJSON === null) {
    return {};
  }

  const flattenObject: { [key: string]: any } = {};

  const flatten = (obj: any, prefix = '') => {
    Object.keys(obj).forEach((key) => {
      const prefixedKey = prefix ? `${prefix}.${key}` : key;
      if (typeof obj[key] === 'object' && obj[key] !== null) {
        flatten(obj[key], prefixedKey);
      } else {
        flattenObject[prefixedKey] = obj[key];
      }
    });
  };

  flatten(nestedJSON);

  return flattenObject;
};

export const convertToNestedJSON = (dynamicJson: Record<string, any>): Record<string, any> => {
  const nestedJson: Record<string, any> = {};

  for (const key in dynamicJson) {
    if (dynamicJson.hasOwnProperty(key)) {
      const parts = key.split('.');
      let currentLevel = nestedJson;

      for (let i = 0; i < parts.length; i++) {
        const part = parts[i];

        if (!currentLevel.hasOwnProperty(part)) {
          currentLevel[part] = {};
        }

        if (i === parts.length - 1) {
          currentLevel[part] = dynamicJson[key];
        } else {
          currentLevel = currentLevel[part];
        }
      }
    }
  }

  return nestedJson;
};
